<form [formGroup]="form" (ngSubmit)="onSubmit()" [mapErrorsFn]="mapErrorsFn" validateOnSubmit>
  <div class="mb-3">
    <label class="form-label" for="current-password">
      {{ 'AbpIdentity::DisplayName:CurrentPassword' | abpLocalization }}
      <span> * </span>
    </label>
    <div class="input-group form-group" validationTarget>
      <input class="form-control" id="current-password" formControlName="currentPassword"
        [abpShowPassword]="showCurrentPassword" />
      <button class="btn btn-secondary" type="button" (click)="showCurrentPassword = !showCurrentPassword">
        <i class="fa" aria-hidden="true" [ngClass]="{
            'fa-eye-slash': !showCurrentPassword,
            'fa-eye': showCurrentPassword
          }"></i>
      </button>
    </div>
  </div>
  <div class="mb-3 d-flex flex-column">
    <label class="form-label" for="new-password">
      {{ 'AbpIdentity::DisplayName:NewPassword' | abpLocalization }}
      <span> * </span>
    </label>
    <div class="input-group form-group" validationTarget>
      <input class="form-control" id="new-password" formControlName="newPassword" [abpShowPassword]="showNewPassword"
        (keyup)="validatePassword()" />
      <button class="btn btn-secondary" type="button" (click)="showNewPassword = !showNewPassword">
        <i class="fa" aria-hidden="true" [ngClass]="{
            'fa-eye-slash': !showNewPassword,
            'fa-eye': showNewPassword
          }"></i>
      </button>
    </div>
    <abp-password-complexity-indicator [progressBar]="progressBar"></abp-password-complexity-indicator>
    @if (progressBar?.width > 0) {
    <div class="d-flex align-items-center order-2 mt-1" style="font-weight: 500">
      {{ 'AbpAccount::Strength' | abpLocalization }}&nbsp;
      <span [style.color]="progressBar?.bgColor">{{
        'AbpAccount::' + progressBar?.text | abpLocalization
        }}</span>
    </div>
    }
  </div>

  <div class="mb-3">
    <label class="form-label" for="confirm-new-password">
      {{ 'AbpIdentity::DisplayName:NewPasswordConfirm' | abpLocalization }}
      <span> * </span>
    </label>
    <div class="input-group form-group" validationTarget>
      <input class="form-control" id="confirm-new-password" formControlName="repeatNewPassword"
        [abpShowPassword]="showConfirmPassword" (keyup)="validatePassword()" />
      <button class="btn btn-secondary" type="button" (click)="showConfirmPassword = !showConfirmPassword">
        <i class="fa" aria-hidden="true" [ngClass]="{
            'fa-eye-slash': !showConfirmPassword,
            'fa-eye': showConfirmPassword
          }"></i>
      </button>
    </div>
  </div>

  <div class="form-check mb-3">
      <input type="checkbox" class="form-check-input" id="privacyPolicy" formControlName="acceptPrivacyPolicy" />
    <label for="privacyPolicy">
      Li e concordo com a <a href="/privacy-policy" target="_blank">política de privacidade</a>
      <span> * </span>
    </label>
    <div
      class="invalid-feedback d-block"
      *ngIf="(form.get('acceptPrivacyPolicy')?.touched || form.get('acceptPrivacyPolicy')?.dirty ) && form.get('acceptPrivacyPolicy')?.hasError('privacyNotAccepted')"
    >
      Para continuar, você deve aceitar a política de privacidade!
    </div>
  </div>

  <abp-button class="d-grid" iconClass="fa fa-check" buttonClass="btn btn-primary color-white" buttonType="submit">
    {{ 'AbpIdentity::Submit' | abpLocalization }}
  </abp-button>
</form>